import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconCheckRounded({
  color = "#669535",
  size = 16,
}: IIconProps): ReactElement {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="8" fill={color} />
      <mask id="path-2-inside-1_12454_17394" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1822 4.50613C12.4549 4.7448 12.4825 5.15939 12.2439 5.43215L6.99389 11.4321C6.86851 11.5755 6.68707 11.6572 6.49666 11.6562C6.30626 11.6553 6.12567 11.5716 6.00175 11.4271L3.75175 8.80209C3.51588 8.5269 3.54775 8.11262 3.82293 7.87674C4.09811 7.64088 4.5124 7.67274 4.74828 7.94793L6.50512 9.99762L11.2561 4.56786C11.4948 4.2951 11.9094 4.26747 12.1822 4.50613Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1822 4.50613C12.4549 4.7448 12.4825 5.15939 12.2439 5.43215L6.99389 11.4321C6.86851 11.5755 6.68707 11.6572 6.49666 11.6562C6.30626 11.6553 6.12567 11.5716 6.00175 11.4271L3.75175 8.80209C3.51588 8.5269 3.54775 8.11262 3.82293 7.87674C4.09811 7.64088 4.5124 7.67274 4.74828 7.94793L6.50512 9.99762L11.2561 4.56786C11.4948 4.2951 11.9094 4.26747 12.1822 4.50613Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        mask="url(#path-2-inside-1_12454_17394)"
      />
    </svg>
  );
}
